<template>
  <div>
    {{ productData.title }}
    <q-chip v-if="productData.is_delete === 1" color="red" text-color="white" label="(停用)" />
  </div>
</template>

<script>
  export default {
    name: "ProductTitle",
    props: {
      productData: {
        type: Object,
        required: true,
        default: {}
      }
    }
  }
</script>

<style scoped>

</style>
